import { CampaignStatus } from "@/types/campaign/campaign-status/campaign-status";
import { ContainerObjetive, MediaCardIcon, TextContainer, Title, LeaderBoardPlace, BoardText, HeartIcon, LikesText } from "./style-component";
import ProgressBar from "@/components/progress-bar/progress-bar";
import heartIcon from '@/assets/icons/heart.svg'
import { ParticipantTableType } from "@/components/table-contest/table-contest-type";
import SkeletonLoader from "@/components/skeleton-loader/skeleton-loader";
import { getRankLabel } from "@/utils/number-to-place/number-to-place";



export const MissionDetails: React.FC<{
    maxProgress: number;
    progress: number;
    status: CampaignStatus;
    title: string;
    src: string;
    isClaimed: boolean;
    isExChange: boolean;
    missionType: string;
    loadingRank: boolean;
    participantRank: ParticipantTableType[];
    rankNumber: string;
}> = ({ title, 
    progress, 
    maxProgress, 
    status, 
    src, 
    isClaimed = false , 
    isExChange = false, 
    missionType, 
    participantRank, 
    loadingRank, 
    rankNumber }) => {

    if (missionType === "Contest") {
        const label = getRankLabel(Number(rankNumber));
        return (
            loadingRank ? (

                <ContainerObjetive>
                    <SkeletonLoader 
                        data-testid="mission-progress-skeleton" 
                        paragraph={false} 
                        title={true} 
                    />
                </ContainerObjetive>
            ) : (
                <ContainerObjetive>
                    <MediaCardIcon src={src} />
                    <TextContainer>
                        <Title>{title}</Title>
                        <LeaderBoardPlace>
                            <BoardText $status={status}>
                                {label}
                            </BoardText>
                            <HeartIcon src={heartIcon} />
                            <LikesText $status={status}>
                                {participantRank[0]?.current_points ?? ''}
                            </LikesText>
                        </LeaderBoardPlace>
                    </TextContainer>
                </ContainerObjetive>
            )
        );
    } else {
        return (
            <ContainerObjetive>
                <MediaCardIcon src={src} />
                <TextContainer>
                    <Title>{title}</Title>
                    <ProgressBar 
                        progress={progress} 
                        minProgress={maxProgress}
                        maxProgress={maxProgress} 
                        status={status} 
                        isClaimed={isClaimed}
                        isExChange={isExChange}
                    />
                </TextContainer>
            </ContainerObjetive>
        );
    }
};

export default MissionDetails;